import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { storeResources } from '../resources';
import { ThunkLogin, ThunkTeamsAutoLogin } from './thunks';
import { LOCAL_STORAGE_REFRESH_TOKEN, LOCAL_STORAGE_TOKEN } from '../../constants/storage';
import { IAuthInitialState, IAuthReducers } from './types';
import { LOGIN } from '../../router/routes';
import { ILoginResponse } from '../../services/auth/types';

const initialState: IAuthInitialState = {
  tokens: {
    access_token: '',
    expires_in: 0,
    refresh_token: '',
    token_type: '',
  },
};

const reducers: IAuthReducers = {
  logOutUser: (state, payload): void => {
    state.tokens = {
      access_token: '',
      refresh_token: '',
      expires_in: 0,
      token_type: '',
    };

    localStorage.removeItem(LOCAL_STORAGE_TOKEN);
    localStorage.removeItem(LOCAL_STORAGE_REFRESH_TOKEN);
    localStorage.removeItem('psa');
    window.location.replace(LOGIN);
  },
};

const authSlice = createSlice({
  extraReducers: builder => {
    builder.addCase(ThunkLogin.fulfilled, (state, action: PayloadAction<ILoginResponse>) => {
      state.tokens = action.payload;
    });
    builder.addCase(ThunkTeamsAutoLogin.fulfilled, (state, action: PayloadAction<ILoginResponse>) => {
      state.tokens = action.payload;
    })
  },
  initialState,
  name: storeResources.AUTH,
  reducers,
});

export default authSlice.reducer;
export const { logOutUser } = authSlice.actions;
